<template>
  <div>
    <div class="das_top_cont">
      <div class="history_box account_input">

        <div class="accountright_cont_box">
          <div class="flex_center_between_box">

            <div style="display: flex;" class="font_size_12">

            </div>
            <el-button style="height: 40px !important;min-height: 40px !important;"
              :class="this.compareList.length == 0 ? ' btn_export btn_exporthui' : 'btn_exportred btn_export'"
              :disabled="this.compareList.length == 0" @click="CollectDelate">Remove</el-button>
          </div>
          <div class="his_sel_box" style="width: 100%">
            <el-table class="spec_table table_height_30 table_font_size_14" :data="yourUsagelist" style="width: 100%"
              empty-text="No Data" @selection-change="handleSelectionChange" ref="treeTable" row-key="id"
              :key="refresh">
              <el-table-column v-if="isOpenSlct" type="selection" width="40 " align="center">
              </el-table-column>
              <el-table-column prop="updateTime" :label="$t('MyDatabase.Date')" align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.updateTime }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="favoriteName" label="Co. Tag" align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.favoriteName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="companyName" width="300"
                class-name="company company_link company_link_tooltip_normal" label="Co. Name" align="left"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="table-content company_link" @click="setid(scope.row)">
                    {{ scope.row.companyName }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column prop="Country" label="Country " align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.countryName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="companyTypeEn" label=" Co. Type " align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.companyTypeEn }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="companyStatusEn" label="Co. Status " align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.companyStatusEn }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="companyDqiEn" label="DQI" align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.companyDqiEn }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="" width="120" align="center">
                <template slot-scope="scope">
                  <span class="flex_center">

                    <el-popover placement="left-star" title="" width="220" :disabled="isChangeProlio" trigger="click"
                      popper-class="ChangeProtliopopover flex_center">
                      <ul class="ChangeProtlio">
                        <el-checkbox-group v-model="checkList" :max="1">
                          <el-checkbox v-for="(item, index) in CollectedList" :key="index" :label="item.id">{{
                            item.name }}</el-checkbox>
                        </el-checkbox-group>
                        <el-button style="height: 40px !important;min-height: 40px !important;"
                          :class="checkList.length == 0 ? ' btn_export btn_exporthui margin-bottom20' : 'btn_export margin-bottom20'"
                          :disabled="checkList.length == 0" @click="ChangeProto(scope.row)">Confirm</el-button>

                      </ul>
                      <svg slot="reference" t="1763451901009" @click="isChangeProlio = false" class="icon"
                        viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15567" width="28"
                        height="28">
                        <path
                          d="M617.2672 722.944H185.4464c-59.136 0-107.264-53.248-107.264-118.7328V198.0928c0-65.4848 48.128-118.7328 107.52-118.7328h431.8208c59.136 0 107.2128 53.248 107.2128 118.7328V604.16c-0.256 65.536-48.3328 118.784-107.4688 118.784zM185.4464 125.44c-33.7408 0-61.184 32.6144-61.184 72.6528V604.16c0 40.0384 27.4432 72.6528 61.44 72.6528h431.8208c33.6896 0 61.1328-32.6144 61.1328-72.6528V198.0928c0-40.0384-27.4432-72.6528-61.1328-72.6528z"
                          p-id="15568" fill="#1296db"></path>
                        <path
                          d="M329.3696 650.24a22.9888 22.9888 0 0 1-23.04-23.04V418.3552c0-65.4848 48.128-118.784 107.52-118.784h206.336a23.04 23.04 0 0 1 0 46.08H413.5936c-33.7408 0-61.44 32.6144-61.44 72.704v209.0496a23.04 23.04 0 0 1-22.784 22.8352zM845.3632 943.1552H413.5936c-59.136 0-107.52-53.248-107.52-118.7328V768a23.04 23.04 0 0 1 46.08 0v56.32c0 40.0384 27.4432 72.6528 61.44 72.6528h431.7696c33.7408 0 61.184-32.6144 61.184-72.6528V418.3552c0-40.0896-27.4432-72.704-61.184-72.704h-62.3616a23.04 23.04 0 1 1 0-46.08h62.3616c59.136 0 107.264 53.2992 107.264 118.784V824.32c0 65.5872-48.128 118.8352-107.264 118.8352z"
                          p-id="15569" fill="#1296db"></path>
                      </svg>

                    </el-popover>
                    <el-tooltip class="tbl_opr_tip flex_center" :visible-arrow="false" effect="light" content="Download"
                      placement="top">
                      <svg @click="Down(scope.row)" t="1723022129119" class="icon margin-left20" viewBox="0 0 1024 1024"
                        version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6324" width="28" height="28">
                        <path
                          d="M491.52 858.112l-108.544-106.496c-8.192-8.192-20.48-8.192-28.672 0-8.192 8.192-8.192 20.48 0 28.672l139.264 135.168c0 2.048 2.048 6.144 4.096 8.192 4.096 4.096 10.24 6.144 16.384 6.144 6.144 0 12.288-2.048 16.384-6.144 2.048-2.048 4.096-4.096 4.096-8.192l139.264-135.168c8.192-8.192 8.192-20.48 0-28.672-8.192-8.192-20.48-8.192-28.672 0l-110.592 108.544v-368.64c0-12.288-8.192-20.48-20.48-20.48s-20.48 8.192-20.48 20.48v366.592z m-399.36-344.064v-307.2c0-45.056 36.864-81.92 81.92-81.92h675.84c45.056 0 81.92 36.864 81.92 81.92v307.2c0 45.056-36.864 81.92-81.92 81.92h-96.256c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h96.256c67.584 0 122.88-55.296 122.88-122.88v-307.2c0-67.584-55.296-122.88-122.88-122.88h-675.84c-67.584 0-122.88 55.296-122.88 122.88v307.2c0 67.584 55.296 122.88 122.88 122.88v-40.96h-4.096v40.96h102.4c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48h-98.304c-45.056 0-81.92-36.864-81.92-81.92z m296.96-237.568c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h245.76c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48h-245.76z"
                          fill="#1296db" p-id="6325"></path>
                      </svg>
                    </el-tooltip>
                  </span>
                </template>
              </el-table-column>
              <template slot="empty">
                <div>
                  <img style="width: 50%;height: 50%;" src="../../../../assets/images/noDate.png" alt="">
                </div>

              </template>
            </el-table>
            <div class="page_i_box" v-if="yourUsagelist.length > 0">
              <Page :totalFont="true" :total="page.total" :pageSize.sync="page.pageSize" :currentPage="page.pageNo"
                @onPageChange="onPageChangeList"></Page>

              <div class="search_rsult_txt line_2">{{ page.pageNo }}-{{ page.pageSize }} of over {{ page.total |
                FilterNum }}
                results for "Companies Collected"</div>
            </div>
            <!-- <div v-if="this.page.total>this.page.pageSize" style="text-align: center; padding-top: 20px">
              <span class="contclass show_All" @click="apptablelist">Show More</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import { getUserCompanyActionPage, updateFavoriteId, removeUserCompanyActions, downloadOnlinePdf, getCollectionList, removeItems } from "@/api/userApi";
import Page from '@/components/page/index.vue';
export default {
  mixins: [mixins1],
  components: {
    Page
  },
  props: {
    isOpenSlct: {
      type: Boolean,
    },

  },
  watch: {
    isOpenSlct: {
      handler(newVal, oldVal) {

        this.isOpenSlct = newVal;
        // 在这里处理columns属性的变化
        if (newVal == false) {
          this.handleSelectionChange([])
          if (this.$refs.treeTable) {
            this.$refs.treeTable.clearSelection();

          }
          this.compareList = []
          this.$store.dispatch("app/setcollectList", []);
          this.$store.dispatch("app/setchangeList", this.compareList);
        }
        this.refresh++

        // 这里可以进行一些逻辑处理或者触发其他操作
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
  },
  data() {
    return {
      reLoginVis: false,

      menuActive: 1,
      datePicker: [],
      checkList: [],
      CategoryVal: "",
      yourUsagelist: [],
      CollectedList: [],
      isChangeProlio: true,
      refresh: 0,
      compareList: [],
      compareListParent: [],
      window: window,
      page: {
        pageSize: 10,
        pageNo: 1,
        total: 0
      },

    };
  },
  beforeDestroy() { },
  destroyed() { },
  mounted() {

    this.$store.dispatch("app/setTools", {

      name: "select",
      key: "isActive",
      value: true,
    });
    this.getgetUserActionLogPage();
    this.getCollectionListData()
  },

  methods: {
    // 删除收藏
    CollectDelate() {

      let ids = []
      this.compareListParent.map((item) => {
        ids.push({
          id: item.id
        });
      });
      removeUserCompanyActions(ids).then(res => {
        if (res.code == 200) {
          this.refresh++;
                  this.handleSelectionChange([])
          this.getgetUserActionLogPage()
          this.compareList = []
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });
        } else {
          this.$message({
            message: res.msg,
            center: true,
            type: "error",
          });
        }
      })
    },
    handleSelectionChange(val) {

      this.compareListParent = val
      this.cheeckbooksUpdate(val)
    },

    cheeckbooksUpdate(val) {
      this.compareList = [...this.compareListParent]

      this.$store.dispatch("app/setTools", {
        name: "riskScanning",
        key: "isActive",
        value: this.compareList.length > 0,
      });
      this.$store.dispatch("app/setTools", {
        name: "customPortfolio",
        key: "isActive",
        value: this.compareList.length > 0,
      });



      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });



      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: this.compareList.length > 0,
      });
      // 添加 选中公司
      this.$store.dispatch("app/setchangeList", this.compareList);
      this.compareList.map(item => {
        item.aaa_id = item.aaaid
      })

      //添加 选中公司 风险扫描
      sessionStorage.setItem('riskScanList', JSON.stringify(this.compareList))


    },
    getCollectionListData() {
      getCollectionList().then((collect) => {
        if (collect.code == 200) {
          this.CollectedList = collect.data;
        } else {
          this.CollectedList = [];
        }
      });
    },
    // 公司切换组合
    ChangeProto(scope) {
      let paramsList = []
      this.checkList.map(item => {
        paramsList.push(
          {
            favoriteId: item,
            id: scope.id
          }
        )
      })
      updateFavoriteId(
        paramsList
      ).then(res => {
        if (res.code == 200) {
          this.isChangeProlio = true
          this.getgetUserActionLogPage()
          this.$message({
            message: res.msg,
            center: true,
            type: 'success',
          });

        } else {
          this.$message({
            message: res.msg,
            center: true,
            type: 'error',
          });
        }
      })
    },
    MenuClick(item) {
      this.menuActive = item.value
    },
    setid(row) {

      let companyCountryEn = "";

      let routeData = this.$router.resolve({
        path:
          "/index/company/detals/" +
          row.aaaid +
          "/background/snapshot?id3a=" +
          row.aaaid +
          "&companyCountry=" +
          '' +
          "&companyCountryEn=" +
          companyCountryEn +
          '&keword=' + this.$route.query.keword,
      });

      window.open(routeData.href, "_blank");

    },
    Down(scope) {
      downloadOnlinePdf(scope.aaaid).then(res => {
        const binaryData = [];
        binaryData.push(res);
        let pdfUrl = window.URL.createObjectURL(
          new Blob(binaryData, { type: "application/pdf" })
        );
        window.open(pdfUrl, '_blank')

      })


    },
    getgetUserActionLogPage() {
      let userinfo = JSON.parse(localStorage.getItem("userInfo")).userInfo;
      getUserCompanyActionPage({
        userId: userinfo.id,
        type: '2',
        portfolioId: '',
        companyName: '',
        companyIsicEn: '',
        companyTypeEn: '',
        companyStatusEn: '',
        startTime: '',
        endTime: '',


        page: this.page.pageNo,
        pageSize: this.page.pageSize,
      }).then((res) => {
        if (res.code == 200) {
          this.yourUsagelist = res.data.rows;
          this.page.total = res.data.total
        } else {
          this.yourUsagelist = [];
        }
      }).catch(err => {
        this.reLoginVis = String(err).includes('403')
      });

    },
    onPageChangeList({ page, size }) {
        this.handleSelectionChange([])
      this.page.pageSize = size;
      this.page.pageNo = page
      this.getgetUserActionLogPage();
    },
    currtentPageChange(pageSize) {
        this.handleSelectionChange([])
      this.page.pageSize = pageSize;
      this.getgetUserActionLogPage()
    },
    apptablelist() {
      this.page.pageSize = this.page.pageSize + 5
      this.getgetUserActionLogPage()
    },
  },
};
</script>
<style scoped>
.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.form-email {
  display: flex;
  width: 100%;
}

.block-con-body-text {
  word-break: keep-all;
  text-align: justify;
  font-size: 1rem;
  color: #022955;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.item_txtcolor1 {
  color: #1290c9;
}

.item_txtcolor2 {
  color: #55b419;
}

.item_txtcolor3 {
  color: #ffa000;
}

.das_top_item .color1 {
  background: rgba(18, 144, 201, 0.12);
}

.das_top_item .color2 {
  background: rgba(85, 180, 25, 0.12);
}

.das_top_item .color3 {
  background: rgba(255, 160, 0, 0.12);
}

.das_top_item .color4 {
  background: #ff7600;
}

.das_top_item .item_img img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
}

.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: left;
}

.das_top_item .item_group {
  margin-left: 0.7142857142857143rem;
  font-size: 1.2857142857142858rem;

  /* width: 17.142857142857142rem; */
}

.das_top_item .item_lab {
  display: block;
  color: #1a2332;

  margin-top: 0.35714285714285715rem;
}

.item_txt {
  font-size: 1.857142857143rem;
  text-align: center;
}

.cont_m {
  margin-top: 2.142857142857143rem;
  margin-bottom: 5.714285714285714rem;
}

.country_box {
  margin-top: 4.285714285714286rem;
}

.country_box .title {
  margin-bottom: 0;
}

.title {
  margin-bottom: 1.4285714285714286rem;
}

.title_txt {
  font-size: 1.1428571428571428rem;
  font-family: 'DMSans Bold';
}

.title_txt img {
  width: 1.4285714285714286rem;
  margin-right: 0.5714285714285714rem;
}

.c_d_buttom {
  justify-content: flex-end;
  /* margin-top: 1.4285714285714286rem; */
  margin-bottom: 0;
}

.btn_blue {
  padding: 0.7142857142857143rem 1.4285714285714286rem;
  background: #1290c9;
  font-size: 1.2857142857142858rem;
  color: #ffffff;
  cursor: pointer;
}

.btn_blu {
  margin-right: 1.4285714285714286rem;
}

.btn_blue img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
  margin-right: 0.42857142857142855rem;
}

.sel_box /deep/ .el-input__inner {
  border-color: #ccc;
  border-radius: 0.5714285714285714rem;
  font-size: 1.1428571428571428rem;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.das_top_item {
  width: 32.5%;
  padding: 1.4285714285714286rem;
  /* border-radius: 1rem; */
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0rem 0.14285714285714285rem 0.2857142857142857rem 0rem rgba(0, 0, 0, 0.12);
}

.das_top_item .item_img {
  width: 4.285714285714286rem;
  height: 4.285714285714286rem;
  line-height: 5.571428571428571rem;
  text-align: center;
  border-radius: 50%;
}

.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: center;
}

.top_tab {
  margin-top: 2.857142857142857rem;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}

.jiange {
  color: #cccccc;
  margin: 0 1.4285714285714286rem;
  font-size: 1.285714285714286rem;
  /* font-size: 1.25em; */
}

.contclass {
  font-size: 1.285714285714286rem;
  color: #1290c9;
  font-style: normal;
}

/deep/ .el-table th.el-table__cell>.cell {
  font-family: 'DMSans Bold';
}

.last-colmun {
  padding: 2rem 0rem;
  border-bottom: 0.07142857142857142rem solid #ebeef5;
}

.dingwei {
  position: absolute;
  top: -2.142857142857143rem;
  right: 0rem;
}

/deep/ .el-descriptions-item__cell {
  padding-bottom: 2.142857142857143rem !important;
}

/deep/ .avatar-uploader .el-upload {
  border: 0.07142857142857142rem dashed #d9d9d9;
  border-radius: 0.42857142857142855rem;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

/deep/ .avatar-uploader-icon {
  font-size: 1.4285714285714286rem;
  color: #8c939d;
  width: 5rem;
  height: 5rem;
  line-height: 5rem;
  text-align: center;
}

/deep/ .avatar {
  width: 5rem;
  height: 5rem;
  display: block;
}

/* 日历大小 */
.el-range-editor.el-input__inner {
  /* width: 16rem !important; */
  padding: 0.21428571428571427rem 0.21428571428571427rem;
}

.el-date-editor /deep/ .el-range__icon {
  font-size: 1.1428571428571428rem;
  margin-left: -0.35714285714285715rem;
  color: #1A2332;
  /* float: left; */
  line-height: 2.2857142857142856rem;
  position: relative;
  left: 47%;
}

@media screen and (max-width: 1441px) {
  .btn_blue {
    font-size: 14px;
    width: max-content;
  }
}

.Data-Management-ul {
  padding: 5px 20px;
  background: #F5F5F5;
  border-radius: 4px;
  width: max-content;
  margin: auto;

}

.Data-Management-ul li {
  padding: 10px 20px;
  cursor: pointer;
}

.menuActiveColor {
  background: #FFFFFF;
  border-radius: 4px;
}

.ChangeProtlio {}

/deep/ .ChangeProtliopopover {
  padding-bottom: 0px !important;
  left: -130px !important;
  width: fit-content !important;
  top: -50px;
}

.el-checkbox {
  display: block;
  margin-bottom: 15px;
}

/deep/ .el-table,
/deep/ .el-table__body-wrapper {
  overflow: visible;
}
</style>